import { render } from "./Panel1.vue?vue&type=template&id=786ef452"
import script from "./Panel1.vue?vue&type=script&lang=js"
export * from "./Panel1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__